/* IMPORT */
import isObservableWritable from './is_observable_writable.js';
import target from './target.js';
import { readable } from '../objects/callable.js';
/* MAIN */
const readonly = (observable, stack) => {
    if (isObservableWritable(observable)) {
        return readable(target(observable), stack);
    }
    else {
        return observable;
    }
};
/* EXPORT */
export default readonly;
